import {CookingItem} from "./CookingItem";
import {Sprite} from "../../Core/Sprite";
import {CookingActivityStep} from "./CookingActivity";
import {Callback} from "../../Core/Reflection";
import {Ease} from "../../Core/Animatable";
import {PointUtil} from "../../Core/Geom";
import {Keyboard} from "../Keyboard";

export abstract class CookingActivityStepMix extends CookingActivityStep {

    readonly bowlMix = this.addChild(new BowlMix());
    readonly spoon = this.addChild(new CookingItem());
    readonly spoonTop = {x: 0, y: 0};

    mix(onComplete: Callback) {
        const spoon = this.spoon;
        const bowl = this.bowlMix;
        let stopMixing = false;
        let isMixing = false;
        let startMixinTime = 0;
        const mixingDuration = 3;
        const mix = () => {
            isMixing = true;
            startMixinTime = new Date().getTime();
            bowl.enabled = false;
            spoon.draggable = false;
            spoon.snapToTarget(() => {

                spoon.changeParent(bowl.visuals);
                spoon.zIndex = bowl.spoon.zIndex;

                const topX = spoon.x;
                const topY = spoon.y;
                const x = bowl.spoon.x;
                const y = bowl.spoon.y;
                const d = bowl.spoon.width * 0.8;
                const a = 12 * Math.PI / 180;
                spoon.tweenTo(0.4, Ease.sineInOut, {
                    x: x - d,
                    y: y,
                    rotation: a,
                    onComplete: () => {
                        spoon.tweenTo(0.6, Ease.sineInOut, {
                            x: x + d,
                            rotation: -a,
                            repeat: -1,
                            yoyo: true,
                            onRepeat: () => {
                                if (stopMixing) {
                                    spoon.killTweens();
                                    spoon.tweenTo(0.3, Ease.sineInOut, {
                                        x: topX,
                                        y: topY,
                                        rotation: 0,
                                        onComplete: () => {
                                            spoon.changeParent(this);
                                            this.moveItemsToRight(spoon, onComplete);
                                        }
                                    });
                                }
                            }
                        });
                    }
                });
            });
        };
        bowl.enabled = true;
        spoon.enabled = true;
        spoon.target = bowl;
        spoon.targetTransform = {
            x: this.spoonTop.x,
            y: this.spoonTop.y,
            rotation: 0
        };
        spoon.pulse();
        spoon.onStartDrag.add(() => {
            spoon.stopPulse();
        });
        spoon.onDrag.add(() => {
            if (PointUtil.distance(spoon, this.spoonTop) < spoon.height * 0.4) {
                mix();
            }
        });
        spoon.onDragged.add(() => {
            spoon.enabled = false;
            if (!isMixing) {
                mix();
            }
            const time = new Date().getTime();
            spoon.delayedCall(Math.max(0, startMixinTime + mixingDuration - time), () => stopMixing = true);
        });
        spoon.onKeyboard.add(() => {
            spoon.stopPulse();
            Keyboard.focus(this.kitchen.buttonHome);
        });
        Keyboard.add(spoon);
        Keyboard.focus(spoon);
    }
}

export class BowlMix extends CookingItem {

    readonly bowlBack = this.visuals.addChild(new Sprite());
    readonly spoon = this.visuals.addChild(new Sprite());
    readonly bowlContent = this.visuals.addChild(new Sprite());
    readonly bowlFront = this.visuals.addChild(new Sprite());

    constructor() {
        super();
        this.enabled = false;
        this.draggable = false;
        this.spoon.visible = false;
    }
}